// packages
import { ChevronLeft, Compass } from 'lucide-react'

// components
import { Logo } from '@/components/common/logo'

export default function NotFound() {
  return (
    <div className="app-shell w-full min-h-screen flex flex-col items-center justify-center text-center px-4">
      <div className="mb-8">
        <Logo size="lg" showText />
      </div>

      <div className="max-w-md w-full bg-card border border-border/50 rounded-3xl p-10 shadow-elevated flex flex-col items-center gap-4">
        <div className="flex items-center justify-center h-16 w-16 rounded-full bg-primary/15 text-coentro">
          <Compass className="h-8 w-8" />
        </div>

        <div className="space-y-1">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Erro 404</span>
          <h1 className="text-3xl font-bold text-foreground">Ops, página não encontrada</h1>
          <p className="text-sm text-muted-foreground max-w-sm mx-auto mt-2">
            A página que você está procurando não existe ou foi movida. Vamos te ajudar a voltar ao caminho certo.
          </p>
        </div>

        <a
          href="/"
          className="mt-2 inline-flex items-center gap-2 bg-primary text-primary-foreground hover:bg-primary/90 font-semibold px-6 py-2.5 rounded-md shadow-soft transition-colors"
        >
          <ChevronLeft className="h-4 w-4" />
          Voltar para o início
        </a>
      </div>
    </div>
  )
}
